"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var _react = _interopRequireDefault(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _loading = require("./loading.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Loading = function Loading() {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _loading.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.loadingBox)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.loading)
  }));
};

exports.Loading = Loading;